module.exports = __webpack_public_path__ + "img/Social_studies_5.0c788caf.svg";